import LegalPage from '../components/ui/LegalPage.jsx'

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      description="FastAudio Privacy Policy — how we collect, use, and protect your information when you use our free video-to-MP3 conversion service."
      slug="privacy"
      lastUpdated="January 2025"
    >
      <p>
        FastAudio ("we", "us", or "our") operates the website at fastaudio.cc. This Privacy Policy
        describes how we collect, use, and protect information when you use our service.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Information We Collect</h2>
      <p>
        We collect minimal information necessary to provide the service. When you submit a URL
        for conversion, that URL is processed server-side and is not stored beyond the duration
        of the conversion job. We may collect anonymous usage statistics (page views, error rates)
        to improve the service.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Cookies</h2>
      <p>
        FastAudio uses only essential cookies (such as your theme preference). We do not use
        advertising or tracking cookies.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Third-Party Services</h2>
      <p>
        The service retrieves publicly accessible media from third-party platforms at your
        direction. We are not responsible for the privacy practices of those platforms.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Data Retention</h2>
      <p>
        Converted audio files are stored temporarily on our servers for download and deleted
        automatically. We do not retain copies of your converted files.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Contact</h2>
      <p>
        For privacy-related enquiries, contact us at{' '}
        <a href="mailto:support@fastaudio.cc" className="text-primary hover:underline">
          support@fastaudio.cc
        </a>.
      </p>

      <p className="mt-6 pt-4 border-t border-border/50 text-xs">
        For the current version of this policy, visit{' '}
        <a href="https://fastaudio.cc/privacy" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
          fastaudio.cc/privacy
        </a>.
      </p>
    </LegalPage>
  )
}
